import { defineComponent as x, useId as v, ref as C, onMounted as k, createBlock as f, openBlock as l, unref as t, normalizeClass as n, withCtx as i, createElementVNode as s, createVNode as m, createElementBlock as u, createCommentVNode as r, renderSlot as d, createTextVNode as V, toDisplayString as b, mergeProps as _ } from "vue";
import { Disclosure as O, DisclosureButton as w, DisclosurePanel as B } from "@headlessui/vue";
import { ScalarIcon as $ } from "@scalar/components";
const D = ["aria-labelledby"], N = { class: "text-c-1 m-0 flex flex-1 items-center gap-1.5 leading-[20px]" }, I = ["id"], S = {
  key: 0,
  class: "sr-only"
}, z = {
  key: 0,
  class: "bg-b-2 text-c-2 inline-flex h-5 w-5 items-center justify-center rounded-full border text-xs font-semibold"
}, E = { class: "sr-only" }, P = {
  key: 0,
  class: "ui-not-open:hidden flex items-center gap-2 pr-0.75"
}, T = /* @__PURE__ */ x({
  __name: "ViewLayoutCollapse",
  props: {
    defaultOpen: { type: Boolean, default: !0 },
    itemCount: { default: 0 },
    layout: { default: "client" }
  },
  emits: ["update:modelValue"],
  setup(y, { emit: h }) {
    const c = h, p = v(), a = C(y.defaultOpen), g = () => {
      a.value = !a.value, c("update:modelValue", a.value);
    };
    return k(() => {
      c("update:modelValue", a.value);
    }), (e, j) => (l(), f(t(O), {
      as: "div",
      class: n(["group/collapse focus-within:text-c-1 text-c-2 last:ui-open:border-b-0 border-b", { "last-of-type:first-of-type:border-b-0": e.layout === "reference" }]),
      defaultOpen: e.defaultOpen,
      static: e.layout === "reference" ? !0 : void 0,
      onClick: g
    }, {
      default: i(({ open: o }) => [
        s("section", {
          "aria-labelledby": t(p),
          class: "contents"
        }, [
          s("div", {
            class: n(["bg-b-2 flex items-center", e.layout === "reference" && "rounded-t-lg border border-b-0"])
          }, [
            m(t(w), {
              class: n([
                "hover:text-c-1 group box-content flex max-h-8 flex-1 items-center gap-2.5 overflow-hidden px-1 py-1.5 text-base font-medium outline-none md:px-1.5 xl:pr-0.5 xl:pl-2",
                { "!pl-3": e.layout === "reference" }
              ]),
              disabled: e.layout === "reference"
            }, {
              default: i(() => [
                e.layout !== "reference" ? (l(), f(t($), {
                  key: 0,
                  class: n([
                    "text-c-3 group-hover:text-c-1 ui-open:rotate-90 ui-not-open:rotate-0 rounded-px outline-offset-2 group-focus-visible:outline"
                  ]),
                  icon: "ChevronRight",
                  size: "md"
                })) : r("", !0),
                s("h2", N, [
                  s("span", {
                    id: t(p),
                    class: "contents"
                  }, [
                    d(e.$slots, "title", { open: o }),
                    o ? r("", !0) : (l(), u("span", S, " (Collapsed) "))
                  ], 8, I),
                  !o && e.itemCount ? (l(), u("span", z, [
                    V(b(e.itemCount) + " ", 1),
                    s("span", E, "Item" + b(e.itemCount === 1 ? "" : "s"), 1)
                  ])) : r("", !0)
                ])
              ]),
              _: 2
            }, 1032, ["class", "disabled"]),
            e.$slots.actions ? (l(), u("div", P, [
              d(e.$slots, "actions", { open: o })
            ])) : r("", !0)
          ], 2),
          m(t(B), _(e.$attrs, { class: "diclosure-panel h-full max-h-fit rounded-b" }), {
            default: i(() => [
              d(e.$slots, "default", { open: o })
            ]),
            _: 2
          }, 1040)
        ], 8, D)
      ]),
      _: 3
    }, 8, ["class", "defaultOpen", "static"]));
  }
});
export {
  T as default
};
